'use client';

import { FeatureFlag } from '@/common/constants/feature-flag.enum';
import { useFeatureFlag } from '@/common/hooks/use-feature-flag.hook';
import {
  selectIsTenant,
  useDomainStore,
} from '@/store/use-domain.store';

/**
 * Resolves whether the appbar search UI should render.
 * Tenant shops always keep their search; Witro marketplace search is Unleash-gated.
 */
export function useShowAppbarSearch(showSearch = false): boolean {
  const isTenant = useDomainStore(selectIsTenant);
  const isWitroSearchEnabled = useFeatureFlag(FeatureFlag.ShopperWitroSearch);

  if (!showSearch) {
    return false;
  }

  if (isTenant) {
    return true;
  }

  return isWitroSearchEnabled;
}
